import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService } from './base-edit.service';
import { HttpService } from '../http.service';
import { NotificationService } from '../notification.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditCopyService<T, TEdit> extends BaseEditService<T, TEdit> {
  protected constructor(
    protected baseRoute: string,
    public name: string,
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(baseRoute, name, httpService, notificationService);
  }

  copy(id: string, key?: string): Observable<string> {
    return this.httpService.get<string>(`${this.apiUrl}/Copy?id=${id}&key=${key}`);
  }
}
